var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowsingAngel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.25H5C4.60218 0.25 4.22064 0.408035 3.93934 0.68934C3.65804 0.970644 3.5 1.35218 3.5 1.75V3.25H2C1.60218 3.25 1.22064 3.40804 0.93934 3.68934C0.658035 3.97064 0.5 4.35218 0.5 4.75V19C0.499997 19.1378 0.537961 19.2729 0.609725 19.3906C0.681489 19.5082 0.784279 19.6038 0.90681 19.6669C1.02934 19.7299 1.16688 19.758 1.30432 19.748C1.44177 19.7381 1.5738 19.6904 1.68594 19.6103L6.5 16.1716L11.315 19.6103C11.4271 19.6901 11.5591 19.7376 11.6964 19.7474C11.8337 19.7573 11.971 19.7291 12.0934 19.6661C12.2158 19.6031 12.3184 19.5076 12.3902 19.3901C12.4619 19.2726 12.4999 19.1377 12.5 19V15.3147L14.3141 16.6103C14.4262 16.6904 14.5582 16.7381 14.6957 16.748C14.8331 16.758 14.9707 16.7299 15.0932 16.6669C15.2157 16.6038 15.3185 16.5082 15.3903 16.3906C15.462 16.2729 15.5 16.1378 15.5 16V1.75C15.5 1.35218 15.342 0.970644 15.0607 0.68934C14.7794 0.408035 14.3978 0.25 14 0.25ZM11 17.5431L6.935 14.6369C6.8078 14.546 6.65538 14.4972 6.49906 14.4972C6.34274 14.4972 6.19033 14.546 6.06312 14.6369L2 17.5422V4.75H11V17.5431ZM14 14.5431L12.5 13.4688V4.75C12.5 4.35218 12.342 3.97064 12.0607 3.68934C11.7794 3.40804 11.3978 3.25 11 3.25H5V1.75H14V14.5431Z",
    fill: "#2A2E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsingAngel);
export default __webpack_public_path__ + "static/media/Browsing Angel.edc3b56ae5545f81963ee4ac03c3e677.svg";
export { ForwardRef as ReactComponent };